module.exports = __webpack_public_path__ + "static/media/logo.de68f8ee.svg";